"use strict";import{Card as e}from"./src/Card.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-card",e);
//# sourceMappingURL=sp-card.js.map
